export default ({ request }) => ({

  personalProjectListApi (data = {}) {
    return request({
      url: '/digitalCenter/project/info/personalProjectList',
      method: 'post',
      data
    })
  }
})
